import $ from "jquery";

function initArticle(item, config, $article, module) {
	const { itemId, image, link } = item;
	
	$article.addClass(this.classNames.item);
	
	if(Array.isArray(image) && image.length) {
		const [data] = image;
		const pi = config.dataParams.image;
		const src = `${config.fileDir}/${pi.dataType}/image${itemId}_1.${data.ext}`;
		$("<div/>").addClass("background").css({
			"background-image": `url("${src}")`
		}).prependTo(
			$article
		);
	}
	
	if(link) {
		const { rootpath } = module.app.config;
		const href = /^\//.test(link) ? `${rootpath.replace(/\/$/, "")}${link}` : link;
		const reg = new RegExp(`^${RegExp.escape(rootpath)}`);
		const target = reg.test(href) ? "_self" : "_blank";
		
		$("<a/>").addClass("go-detail").attr({ href, target }).appendTo(
			$article
		);
	}
}

export default initArticle;

